export const WIDGET_MARGIN = 10;

export const DEFAULT_WIDGET_HEIGHT = 368 + 2 * WIDGET_MARGIN;

export const KICKSTART_OKR_WIDGET = {
  id: "kickstart-okr",
  x: 0,
  y: 1000,
  w: 2,
  sizeToContent: true,
  noMove: true,
  noResize: true,
  noShadow: true,
  selector: "kickstart-okr-widget",
};

const VIEW_ONLY_WIDGETS = [
  { id: "view-alignment", x: 0, y: 1000, w: 1, h: DEFAULT_WIDGET_HEIGHT, noMove: true, noResize: true, noShadow: true, selector: "view-alignment-widget" },
  { id: "view-feed", x: 1, y: 1000, w: 1, h: DEFAULT_WIDGET_HEIGHT, noMove: true, noResize: true, noShadow: true, selector: "view-feed-widget" },
  KICKSTART_OKR_WIDGET,
];

export const SUPPORTED_WIDGETS = [
  { id: "my-okrs", x: 0, y: 0, w: 2, sizeToContent: true, noResize: true, selector: "my-okrs-widget" },
  { id: "check-ins", x: 0, y: 1, w: 1, minH: DEFAULT_WIDGET_HEIGHT, sizeToContent: DEFAULT_WIDGET_HEIGHT, selector: "check-ins-widget" },
  { id: "to-do", x: 1, y: 1, w: 1, minH: DEFAULT_WIDGET_HEIGHT, sizeToContent: DEFAULT_WIDGET_HEIGHT, selector: "todos-widget" },
  { id: "whiteboards", x: 0, y: 2, w: 2, sizeToContent: DEFAULT_WIDGET_HEIGHT, selector: "whiteboards-widget" },
  ...VIEW_ONLY_WIDGETS,
];
